import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _isNil from "lodash/isNil";
var _excluded = ["src", "alt"];
import React from 'react';
export function SvgImage(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var _React$useState = React.useState(typeof src === 'string' ? src : undefined),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      finalSrc = _React$useState2[0],
      setFinalSrc = _React$useState2[1];

  React.useEffect(function () {
    if (typeof src === 'function') {
      src().then(function (_ref2) {
        var img = _ref2["default"];
        return setFinalSrc(img);
      })["catch"](function (e) {
        console.error(e);
        setFinalSrc('');
      });
    } else {
      setFinalSrc(src);
    }
  }, [src]);
  return _isNil(finalSrc) ? null : /*#__PURE__*/React.createElement("img", Object.assign({
    src: finalSrc,
    alt: alt
  }, restProps));
}
// #sourceMappingURL=SvgImage.js.map